<template>
  <v-card
    class="mx-auto overflow-y-auto"
    max-height="150"
    style="max-width: 500px;"
  >
    <v-divider></v-divider>
    <v-card>
      <v-card-text>
        Atenção, no período de 01 de janeiro a 31 de março de 2021, os veículos
        de transporte interurbano de passageiros por fretamento deverão portar
        obrigatoriamente, além da licença especial de viagem para fretamento
        emitida pela ARCE, os seguintes documentos: 1) apólice de seguro do
        veículo, acompanhada de seu comprovante de quitação, ou a última parcela
        vencida paga; 2) laudo de responsabilidade técnica emitido por
        engenheiro com registro no CREA, com a devida Anotação de
        Responsabilidade Técnica (ART), com data de emissão inferior a 12 (doze)
        meses; e 3) o Certificado de Registro e Licenciamento de Veículo (CRLV).
        Na ausência de quaisquer documentos acima, a empresa transportadora
        estará passível das sanções administrativas previstas na Lei Estadual nº
        13.094/2001.

        <v-checkbox
          v-model="agree"
          @click="confirm"
          color="green"
        >
          <template v-slot:label>
            Li e estou ciente dos termos acima.
          </template>
        </v-checkbox>
      </v-card-text>
    </v-card>
  </v-card>
</template>
<script>
export default {
  name: "AutorizacaoTermos",

  data() {
    return {
      agree:false
    };
  },
  methods: {
    confirm() {
      this.$emit("acept", this.agree);
    }
  },
  mounted() {}
};
</script>

<style></style>
